import { render, staticRenderFns } from "./shopTemplate.vue?vue&type=template&id=3195a9a3&scoped=true"
import script from "./shopTemplate.vue?vue&type=script&lang=js"
export * from "./shopTemplate.vue?vue&type=script&lang=js"
import style0 from "./shopTemplate.vue?vue&type=style&index=0&id=3195a9a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195a9a3",
  null
  
)

export default component.exports